import { styled } from '@mui/material/styles'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import Tab from '@mui/material/Tab'

export const StyledBox = styled(Box)(() => ({
	flexGrow: 1
}))

export const StyledBoxWithSeparator = styled(Box)(({ theme }) => ({
	position: 'relative',
	paddingRight: '0.5rem',
	[theme.breakpoints.up('md')]: {
		paddingRight: '1.5rem'
	},
	marginRight: '0.75rem',
	[theme.breakpoints.up('sm')]: {
		marginRight: '1.5rem'
	},
	':after': {
		content: '""',
		display: 'block',
		width: '1.5px',
		height: '78%',
		[theme.breakpoints.up('sm')]: {
			height: '83%'
		},
		backgroundColor: theme.palette.primary.tint2,
		position: 'absolute',
		top: '5px',
		bottom: 0,
		left: '100%'
	}
}))

export const StyledAppBar = styled(AppBar)(({ theme }) => ({
	backgroundColor: theme.palette.white,
	color: theme.palette.primary.main,
	fontFamily: theme.typography.fontFamily,
	fontWeight: 900,
	zIndex: 1200
}))

export const StyledToolBar = styled(Toolbar)(({ theme }) => ({
	justifyContent: 'space-between',
	padding: theme.spacing(0, 0.75),
	[theme.breakpoints.up('md')]: {
		justifyContent: 'flex-start'
	}
}))

export const StyledTab = styled(Tab)(({ theme }) => ({
	textTransform: 'none',
	display: 'flex',
	borderRadius: '0.625rem', // 10px
	borderWidth: '1px',
	borderColor: theme.palette.primary.tint3,
	borderStyle: 'solid',
	width: '130px',
	height: '111px',
	padding: '10px',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: 'center',
	gap: '4px',
	color: theme.palette.primary.main,
	fontSize: '14px',
	fontWeight: '350',
	lineHeight: '20px' /* 142.857% */,
	letterSpacing: '0.2px',
	'&:hover': {
		color: theme.palette.secondary.orange,
		textDecoration: 'underline',
		'> .MuiSvgIcon-root': {
			color: theme.palette.secondary.orange
		}
	},
	'&.Mui-selected': {
		backgroundColor: theme.palette.secondary.orange,
		color: theme.palette.white,
		'> .MuiSvgIcon-root': {
			color: theme.palette.white
		}
	}
}))
